import { Avatar } from "antd";
import React from "react";

const PrivateTagAvatar = ({ size = 14, src = null, isMobileView = false }) => {
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase() + string.slice(1);
  }
  return (
    <div
      style={{
        position: "absolute",
        top: isMobileView ? "-4px" : "-8px",
        left: "-8px",
        zIndex: 99,
      }}
    >
      {userProfile?.Profiles?.PictureUrl ? (
        <Avatar
          size={size}
          src={
            src ||
            `${process.env.REACT_APP_S3_URL}${
              userProfile?.Profiles?.PictureUrl?.charAt(0) !== "/" ? "/" : ""
            }${userProfile?.Profiles?.PictureUrl}`
          }
        />
      ) : (
        <Avatar size={size}>
          {userProfile?.Profiles?.FirstName &&
            capitalizeFirstLetter(userProfile?.Profiles?.FirstName?.charAt(0))}
        </Avatar>
      )}
    </div>
  );
};

export default PrivateTagAvatar;
